/* global jQuery COMPONENTS */

COMPONENTS.ComponentSpecials = (function ($) {
  function ComponentSpecials () {
    this.$component = $('[data-ecs-component="component-specials"]')
    this.$anchors = $('a')
    this.$specialsOnLoad = $('[data-ecs-specials-on-load]')
  }

  /**
   * Get a cookie value by name
   */
  ComponentSpecials.prototype.getCookieValue = function (name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  }

  /**
   * Set a cookie (site-wide path for reliability)
   */
  ComponentSpecials.prototype.setSpecialsCookie = function (name, value, exdays) {
    const d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    const expires = 'expires=' + d.toUTCString()
    document.cookie = name + '=' + value + ';' + expires + '; path=/'
  }

  /**
   * Check if we should open the specials popup based on iteration and cookies
   */
  ComponentSpecials.prototype.shouldOpenSpecials = function ($element) {
    const currentIteration = $element.data('specials-iteration') || '1'
    const anchor = $element.data('specials-anchor') || 'specials'
    const ignoreCookies = $element.data('specials-ignore-cookies') === 1
    const homePageOnly = $element.data('specials-home-page-only') === 1
    const isHomePage = $('body').hasClass('property-home')

    // Check homepage restriction
    if (homePageOnly && !isHomePage) {
      return false
    }

    // If ignoring cookies, always show
    if (ignoreCookies) {
      return true
    }

    // Check cookie for this specific specials component
    const cookieName = '_componentsSpecial_' + anchor
    const storedIteration = this.getCookieValue(cookieName) || ''

    console.log('Specials check:', { cookieName, storedIteration, currentIteration, match: String(storedIteration) === String(currentIteration) })

    // If iteration has changed (or no cookie exists), show and update cookie
    // Convert both to strings for comparison since iteration can be a hash
    if (String(storedIteration) !== String(currentIteration)) {
      this.setSpecialsCookie(cookieName, currentIteration, 365)
      console.log('Setting cookie:', cookieName, '=', currentIteration)
      return true
    }

    return false
  }

  ComponentSpecials.prototype.init = function () {
    const component = this
    component.$anchors.each(function () {
      // Set a scoped reference to the anchor and href
      const $anchor = $(this)
      // If it doesn't have an href make sure to pass along an empty string
      // to the rest of the functiob below to prevent undefined errors
      const href = ($anchor.attr('href') ? $anchor.attr('href') : '')

      // Handle fancybox inline content
      if (href.includes('#components-specials')) {
        const link = href
        $anchor.attr('data-fancybox', '')
        $anchor.attr('data-src', link)
        $anchor.attr('href', 'javascript:;')
      }
    })

    if (component.$specialsOnLoad.length > 0) {
      // Function to open specials popup
      const openSpecials = function () {
        component.$specialsOnLoad.each(function () {
          const $specialsComponent = $(this)
          
          // Check if we should open this specials component
          if (component.shouldOpenSpecials($specialsComponent)) {
            $.fancybox.open({
              src: '#' + $specialsComponent.attr('id'),
              type: 'inline'
            })
          }
        })
      }

      // Wait for window load to ensure Fancybox is fully loaded
      if (document.readyState === 'complete' && typeof $.fancybox !== 'undefined') {
        openSpecials()
      } else {
        $(window).on('load', function () {
          openSpecials()
        })
      }
    }
  }

  return ComponentSpecials
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentSpecials = new COMPONENTS.ComponentSpecials()
  COMPONENTS.componentSpecials.init()
})
